import { useCallback, useContext, useEffect, useState } from "react";

import { useFetch } from "hooks";

import { HubContext } from "scenes/Hubly/components/Workspace/Provider";

export function useView({ updateFilter = () => {} } = {}) {
  const { fetchView, fetchDefaultView } = useContext(HubContext);

  const [currentView, setCurrentView] = useState(undefined);
  const [viewId, setViewId] = useState(undefined);
  const [resolving, setResolving] = useState(true);

  const {
    loading: loadingDefaultView,
    numOfFetches: defaultViewFetches,
    error: defaultViewError,
    data: [defaultViewId],
  } = useFetch(fetchDefaultView);

  const defaultViewSettled =
    (defaultViewFetches > 0 && !loadingDefaultView) ||
    Boolean(defaultViewError);

  const {
    error: viewError,
    reloadData,
    data: [view],
  } = useFetch(fetchView, {
    variables: viewId,
    options: { fetchOnInit: false },
  });

  const callFetchView = useCallback(
    (id) => {
      setResolving(true);
      setViewId(id);
      reloadData();
    },
    [reloadData]
  );

  useEffect(() => {
    if (!defaultViewSettled) return;

    if (defaultViewId) callFetchView(defaultViewId);
    else setResolving(false);
  }, [defaultViewSettled, defaultViewId, callFetchView]);

  useEffect(() => {
    if (view) {
      setCurrentView(view);
      updateFilter({ type: "filters", value: view.filters });
      updateFilter({ type: "workflows", value: view.workflows });
      setResolving(false);
    }
  }, [view, updateFilter]);

  useEffect(() => {
    if (viewError) setResolving(false);
  }, [viewError]);

  return {
    loading: resolving,
    currentView: currentView,
    updateCurrentView: setCurrentView,
    clearView: () => {
      updateFilter({ type: "clearAll" });
      setCurrentView(undefined);
    },
    fetchView: callFetchView,
  };
}

export default useView;
